import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import ManagementBillingDash from "./management-billing-dashboard/ManagementBillingDash";


export default function ManagementBillingDetailsPage() {
  
  return (
    <ToastProvider>
      <Dashboard>
        <ManagementBillingDash />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

